import { render, staticRenderFns } from "./CardOthersInfoPolicy.vue?vue&type=template&id=e6ea775e"
import script from "./CardOthersInfoPolicy.vue?vue&type=script&lang=js"
export * from "./CardOthersInfoPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports